import React, { useState } from 'react';
import { Tasks, AddTask, EditTask } from '../containers';
import {
  useActiveListContext,
  useShowTaskEditOptionsContext,
  TargetListAddProvider,
  TargetListEditProvider,
  ShowTaskEditBoxProvider,
  DateTimeProvider,
  useTaskContext,
} from '../../context';
import { Core } from '..';
import { TaskHeading, ScrollBox, BackButton } from './styles';
import { Desktop, Mobile } from '../../media_queries';
import { FaChevronLeft } from 'react-icons/fa';
import { FillSpace } from '../dnd_list/styles';

export default function TaskBox({ setShowTasks = null }) {
  const { listName, themeColor } = useActiveListContext();
  const {
    showTaskEditOptions,
    setShowTaskEditOptions,
  } = useShowTaskEditOptionsContext();
  const { tasks } = useTaskContext();
  const [progress, setProgress] = useState(0);
  const [isInDelete, setIsInDelete] = useState(false);

  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={isInDelete}
      >
        Task Completed
      </Core.ForceAlert>

      <Core.InlineLayout
        justifyContent='space-between'
        style={{ padding: '0 10px' }}
      >
        {setShowTasks && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              marginBottom: '1.25em',
            }}
          >
            <BackButton color={themeColor} onClick={() => setShowTasks(false)}>
              <span className='icon'>
                <FaChevronLeft />
              </span>
              <span
                style={{
                  textShadow: '0 4px 6px rgb(0 0 0 / 40%)',
                }}
              >
                Back
              </span>
            </BackButton>
          </div>
        )}
        <TaskHeading
          style={{
            wordBreak: 'break-all',
            color: themeColor,
            visibility: listName ? 'visible' : 'hidden',
          }}
        >
          {listName ? listName : 'hidden'}
        </TaskHeading>

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            marginBottom: '1em',
            opacity: tasks && tasks.length > 0 ? 1 : 0,
            pointerEvents: tasks && tasks.length > 0 ? 'auto' : 'none',
            transition: 'all 0.25s ease-in-out',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                color: themeColor,
                marginRight: '5px',
                marginTop: '2.5px',
                fontWeight: 'bold',
                textShadow: '0 4px 6px rgb(0 0 0 / 50%)',
              }}
            >
              Edit
            </div>
            <Core.Switch
              style={{ boxShadow: '0 0 10px 3px rgb(0 0 0 / 25%)' }}
              color={themeColor}
              value={showTaskEditOptions}
              onClick={() => setShowTaskEditOptions(!showTaskEditOptions)}
            ></Core.Switch>
          </div>
        </div>
      </Core.InlineLayout>

      <Desktop>
        <ShowTaskEditBoxProvider>
          <DateTimeProvider>
            <TargetListAddProvider>
              <ScrollBox>
                <Tasks
                  setProgress={setProgress}
                  isInDelete={isInDelete}
                  setIsInDelete={setIsInDelete}
                />
                <FillSpace></FillSpace>
              </ScrollBox>

              <AddTask />
            </TargetListAddProvider>

            <TargetListEditProvider>
              <EditTask />
            </TargetListEditProvider>
          </DateTimeProvider>
        </ShowTaskEditBoxProvider>
      </Desktop>

      <Mobile>
        <ScrollBox forMobile={true}>
          <Tasks
            forMobile={true}
            setProgress={setProgress}
            isInDelete={isInDelete}
            setIsInDelete={setIsInDelete}
          />
          <FillSpace></FillSpace>
        </ScrollBox>

        <AddTask />

        <EditTask />
      </Mobile>
    </>
  );
}
